import React, { useContext, useEffect, useRef } from 'react';
import './Event.css';
import convenienceApi from '../../common/api/convenience';
import Card from '../Card/Card';
import CardContent from '../Card/CardContent';
import EventContent from './EventContent';
import EventLoadingStatus from './EventLoadingStatus';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { CardNextEventContext } from '../../contexts/CardNextEventContext';
import logComponent from '../../common/logComponent';

export default function Event({ moduleDescription }) {
  const environmentContext = useContext(EnvironmentContext);
  //Note:  We are using context for data and time range because it wasn't updating the CardContent children when data changed or current time stamp changed
  const cardNextEventContext = useContext(CardNextEventContext);
  const { hasToken } = environmentContext;
  const { nextEvent } = cardNextEventContext
  const loadingRef = useRef(false);

  if (logComponent('Event')) { console.debug('Event rendered'); }

  const setLoadingRef = (el) => {
    if (logComponent('Event')) { console.debug('Event setLoadingRef'); }
    loadingRef.current = el;
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('Event')) { console.debug('Event onMount'); }
    if (!hasToken) return;
  }, []);

  useEffect(() => {
    if (logComponent('Event')) { console.debug('Event useEffect [environmentContext.hasToken, environmentContext.selectedMonitoredIndividual]'); }
    if (!hasToken) return;

    loadEvent();
  }, [environmentContext.hasToken, environmentContext.selectedMonitoredIndividual]);


  const loadEvent = () => {
    if (logComponent('Event')) { console.debug('Event loadEvent'); }
    if (!hasToken || loadingRef.current) return;
    setLoadingRef(true);

    const { setNextEvent, setNextEventLoading, setNextEventError } = cardNextEventContext;


    setNextEvent(null);
    setNextEventLoading(true);
    setNextEventError(false);



    const { activeUser: user, selectedMonitoredIndividual } = environmentContext;

    convenienceApi.getNextEvent(user, selectedMonitoredIndividual)
      .then(
        result => {
          setNextEvent(result);
          setNextEventLoading(false);
          setNextEventError(false);
          setLoadingRef(false);
       },
        error => {
          setNextEvent(null);
          setNextEventLoading(false);
          setNextEventError(true);
          setLoadingRef(false);
        });
  }

  return (
    <Card className="Event" title="Next event" moduleDescription={moduleDescription} icon="video" dataLoaded={!!nextEvent} >
      <CardContent>
        <EventContent />
        <EventLoadingStatus reloadAction={loadEvent} />
      </CardContent>
    </Card>
  )
}
